<div class="entitlements-container">
  <div class="entitlements-header">
    <h1 class="page-title">{{ 'ENTITLEMENTS_PAGE.TITLE' | translate }}</h1>
    <p class="page-subtitle">{{ 'ENTITLEMENTS_PAGE.SUBTITLE' | translate }}</p>
  </div>

  @if (state.isEntitlementsLoading()) {
    <div class="loading-state">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  } @else if (state.entitlements().length === 0) {
    <div class="empty-state">
      <div class="empty-icon-wrap">
        <mat-icon>local_parking</mat-icon>
      </div>
      <h3>{{ 'ENTITLEMENTS_PAGE.NO_ENTITLEMENTS' | translate }}</h3>
    </div>
  } @else {
    <div class="spaces-list">
      @for (space of state.entitlements(); track space.parkingSpaceId || space.name) {
        <div class="space-card">
          <div class="space-card-header">
            <div class="space-icon">
              <mat-icon>location_on</mat-icon>
            </div>
            <div class="space-info">
              <h2 class="space-name">{{ space.name || 'Parking Area' }}</h2>
            </div>
          </div>

          <div class="zones-section">
            <h4 class="zones-heading">{{ 'ENTITLEMENTS_PAGE.ZONES_LABEL' | translate }}</h4>
            <div class="zones-grid">
              @for (zone of space.zones; track zone.parkingZoneId || zone.name) {
                <div
                  class="zone-item"
                  [class.included]="isIncluded(zone.status)"
                  [class.extra]="isNotIncluded(zone.status)"
                  [class.unavailable]="isNotAvailable(zone.status)">
                  <div class="zone-info">
                    <mat-icon class="status-icon">
                      {{ isIncluded(zone.status) ? 'check_circle' : (isNotIncluded(zone.status) ? 'info' : 'block') }}
                    </mat-icon>
                    <span class="zone-name">{{ zone.name || 'Zone' }}</span>
                  </div>
                  <span class="entitlement-tag">
                    {{ getStatusLabelKey(zone.status) | translate }}
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
